import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CommonPopupSearchComponent } from '../../common-popup-search/common-popup-search.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ReportlinksserviceService } from '../../reportlinks/reportlinksservice.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { DatasetActionButtons } from 'src/app/shared/common/DatasetActionButtons';
import { CellEditorSelectorResult, ICellEditorParams, RowDragEndEvent, RowDragEnterEvent, RowDragLeaveEvent, RowDragMoveEvent } from 'ag-grid-community';
import { ManageVisualsService } from 'src/app/shared/services/manage-visuals.service';
import { ErrorMessages } from 'src/app/shared/common/errormessages';

export interface visualEditData {
  editData: any;
}



@Component({
    selector: 'app-pivot-configuration-popup',
    templateUrl: './pivot-configuration-popup.component.html',
    styleUrls: ['./pivot-configuration-popup.component.scss'],
    standalone: false
})
export class PivotConfigurationPopupComponent implements OnInit {

  validations_form: UntypedFormGroup;
  getDataSetData: any = [];
  selectedDataset:any="";

  visualTypeData=[
    {
      visualTypeName:"Tabular"
    },
    {
      visualTypeName:"Pivot"
    }
  ]
  allocateButtonsBoolean = false;
  allocateButtons1Boolean=true;
  backgroundColorButton = "";
  dataSetObject = {
    datasetId: '',
    filtername: '',
    filterDescription: '',
    datasetName: '',
    reportcreationid: '',
    defaultFilter:"",
    filters: [],
    s3Path:'',
    isExternalFile:'',
    columns:[],
    visualConfig:[],
    visualType:'',
    concatination:[],
    aggregate:[],
    rollingUp:[]
  }
  visualName;
  visualObjectList=[]
  visualObject={
    columnName:"",
    columnType:"",
    vauleCountType:"",
    sortBy:false,
  }
  showList:boolean=false;
  selectedDatasetObject:any;
  columnDefsForTabularFields
  columnDefsForTabularconcatinationFields
  columnDefsForTabularAggregateFields
  columnDefsForTabularRollingUpFields
  
  columnDefsForTablesFields;
  columnDefsForSelectedFields;
  columnDefsForSelectedValues;
  columnDefsForSelectedColumns
  defaultColDef;
  rowSelectionForTablesFields;
  components;
  ngModelObjectTemporary;
  paramstemp;
  tabularParams;
  tabularconcatinationParams;
  tabularaggregateParams;
  tabularrollingUpParams;
  selectedFieldsData;
  sortingOrder;
  selectedTableFields;
  selectedColumns;
  selectedValues;
  rowGridOptions;
  columnsGridOptions;
  valueGridOptions;

  sortByList=[]
  selectedRowsData=[];
  selectedColumnsData=[];
  selectedValuesData=[];
  selectedRowsDataToRemove;
  selectedColumnsDataToRemove;
  selectedValuesDataToRemove;

  tableProperties:any={
    title:"",
    subTitle:"",
    layout:"TABULAR",
    valuesPosition:"",
    totalOptionsRowChecked:false,
    totalOptionsColumnsChecked:false,
    subtotalOptionsRowChecked:false,
    subtotalOptionsColumnsChecked:false,
    rowsTotal:{
      label:"Total",
      position:"Bottom"
    },
    columnsTotal:{
      label:"Total",
      position:"Bottom"
    },
    rowsSubTotal:{
      label:"Subtotal",
      level:"",
      customAttributesSelected:[]
    },
    columnsSubTotal:{ 
      label:"Subtotal",
      level:"",
      customAttributesSelected:[]
    },
    headers:{
      rowsLabel:"",
      visibility:"VISIBLE"
    },
    visualConfig:[]
  }

  openPanels: { [key: string]: boolean } = {
    panel1: false,  // Default: panel1 (Display Settings) is open
    panel2: false,
    panel3: false,
    panel4: false,
    panel5: false,
    panel6: false
  };

  existingData;
  buttonName;

  validation_messages;
  constructor(
    private dialog: MatDialog,
    private linkservice: ReportlinksserviceService,
    private localStorageSettings: LocalStorageSettingsService,
    private snackbar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    public dialogref: MatDialogRef<PivotConfigurationPopupComponent>,
    private validation: validationmethod,
    private visualServices:ManageVisualsService,
    @Inject(MAT_DIALOG_DATA) public data:visualEditData,
    private msg: ErrorMessages
  ) { 
    this.validation_messages = this.msg.pivotConfiguration;
    this.components = {
      buttonRenderer: DatasetActionButtons,
    }
  }

  ngOnInit(){
   
    
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
    
    
    this.rowGridOptions = {
      rowDragManaged: true,
      onRowDragEnd: this.onRowDragEnd.bind(this),
      animateRows: true
    };
    this.columnsGridOptions = {
      rowDragManaged: true,
      onRowDragEnd: this.onRowDragEnd.bind(this),
      animateRows: true
    };
    this.valueGridOptions = {
      rowDragManaged: true,
      onRowDragEnd: this.onRowDragEnd.bind(this),
      animateRows: true
    };
    this.columnDefsForTabularFields=[
      {
        headerName: "Show In Visuals",
        headerTooltip: "Show In Visuals",
        tooltipValueGetter: params => "Show In Visuals : " + params.value,
        field: "alias",
        filter: "agTextColumnFilter",
        width: 250,
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly:true,
        cellStyle: { " padding-left": "5px" }
      },
      { headerName: 'Label', 
        headerTooltip: 'Label', 
        tooltipValueGetter: params => 'Label : ' + params.value, 
        field: 'QSlabel', 
        filter: 'agTextColumnFilter', 
        cellEditor: 'agTextCellEditor', 
        editable: true,
        width: 150 
      },
      { headerName: 'Visibility', 
        headerTooltip: 'Visibility', 
        tooltipValueGetter: params => 'Visibility : ' + params.value, 
        field: 'visibility', 
        filter: 'agTextColumnFilter', 
        cellEditor: 'agSelectCellEditor', // Use agSelectCellEditor for dropdowns in Community version
          cellEditorParams: {
            values: ['VISIBLE', 'HIDDEN'], // Dropdown values
          },
        editable: true,
        width: 100 
      },
      {
        headerName: "Sort By Column",
        headerTooltip: "Sort By Column",
        tooltipValueGetter: params => "Sort By Column : " + params.value,
        field: "sortBy",
        cellRenderer: params => {
          const checkbox = document.createElement('input');
          checkbox.type = 'checkbox';
          checkbox.checked = params.value;
          checkbox.disabled = !params.data.showInVisual;
    
          // Prevent row selection on click
          checkbox.addEventListener('click', function(event) {
            event.stopPropagation();
          });
    
          // Bind checkbox state to the underlying data
          checkbox.addEventListener('change', function() {
            if (checkbox.checked) {
              const allRows = params.api.getRenderedNodes(); // Get all rows in the grid
      
              allRows.forEach(rowNode => {
                if (rowNode.data !== params.data) {
                  rowNode.setDataValue('sortBy', false); // Uncheck all other checkboxes
                }
              });
      
              // Set the value for the currently selected checkbox
              params.setValue(checkbox.checked);
            }
          });
    
          return checkbox;
        },
        editable: true,
        width: 100,
      }
    ]

    this.columnDefsForTabularconcatinationFields=[
      {
        headerName: "Show In Visuals",
        headerTooltip: "Show In Visuals",
        tooltipValueGetter: params => "Show In Visuals : " + params.value,
        field: "alias",
        filter: "agTextColumnFilter",
        width: 300,
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly:true,
        cellStyle: { " padding-left": "5px" }
      },
      { headerName: 'Label', 
        headerTooltip: 'Label', 
        tooltipValueGetter: params => 'Label : ' + params.value, 
        field: 'QSlabel', 
        filter: 'agTextColumnFilter', 
        cellEditor: 'agTextCellEditor', 
        editable: true,
        width: 150 
      },
      { headerName: 'Visibility', 
        headerTooltip: 'Visibility', 
        tooltipValueGetter: params => 'Visibility : ' + params.value, 
        field: 'visibility', 
        filter: 'agTextColumnFilter', 
        cellEditor: 'agSelectCellEditor', // Use agSelectCellEditor for dropdowns in Community version
          cellEditorParams: {
            values: ['VISIBLE', 'HIDDEN'], // Dropdown values
          },
        editable: true,
        width: 100 
      }
    ]

    this.columnDefsForTabularAggregateFields=[
      {
        headerName: "Show In Visuals",
        headerTooltip: "Show In Visuals",
        tooltipValueGetter: params => "Show In Visuals : " + params.value,
        field: "alias",
        filter: "agTextColumnFilter",
        width: 300,
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly:true,
        cellStyle: { " padding-left": "5px" }
      },
      { headerName: 'Label', 
        headerTooltip: 'Label', 
        tooltipValueGetter: params => 'Label : ' + params.value, 
        field: 'QSlabel', 
        filter: 'agTextColumnFilter', 
        cellEditor: 'agTextCellEditor', 
        editable: true,
        width: 150 
      },
      { headerName: 'Visibility', 
        headerTooltip: 'Visibility', 
        tooltipValueGetter: params => 'Visibility : ' + params.value, 
        field: 'visibility', 
        filter: 'agTextColumnFilter', 
        cellEditor: 'agSelectCellEditor', // Use agSelectCellEditor for dropdowns in Community version
          cellEditorParams: {
            values: ['VISIBLE', 'HIDDEN'], // Dropdown values
          },
        editable: true,
        width: 100 
      }
    ]

    this.columnDefsForTabularRollingUpFields=[
      {
        headerName: "Show In Visuals",
        headerTooltip: "Show In Visuals",
        tooltipValueGetter: params => "Show In Visuals : " + params.value,
        field: "rollupColumnAlias",
        filter: "agTextColumnFilter",
        width: 300,
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly:true,
        cellStyle: { " padding-left": "5px" }
      },
      { headerName: 'Label', 
        headerTooltip: 'Label', 
        tooltipValueGetter: params => 'Label : ' + params.value, 
        field: 'QSlabel', 
        filter: 'agTextColumnFilter', 
        cellEditor: 'agTextCellEditor', 
        editable: true,
        width: 150 
      },
      { headerName: 'Visibility', 
        headerTooltip: 'Visibility', 
        tooltipValueGetter: params => 'Visibility : ' + params.value, 
        field: 'visibility', 
        filter: 'agTextColumnFilter', 
        cellEditor: 'agSelectCellEditor', // Use agSelectCellEditor for dropdowns in Community version
          cellEditorParams: {
            values: ['VISIBLE', 'HIDDEN'], // Dropdown values
          },
        editable: true,
        width: 100 
      }
    ]

    this.columnDefsForTablesFields = [
      {
        headerName: "Attributes ",
        headerTooltip: "Attributes",
        tooltipValueGetter: params => "Attributes : " + params.value,
        field: "alias",
        filter: "agTextColumnFilter",
        width: 345,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellStyle: { " padding-left": "5px" }
      }
    ];

    this.columnDefsForSelectedFields = [
      {
        headerName: "Rows",
        tooltipValueGetter: params => "Selected Attributes : " + params.value,
        field: "alias",
        filter: "agTextColumnFilter",
        width: 200,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellStyle: { " padding-left": "5px" },
        editable: true,
        rowDrag: true
      },
      { headerName: 'Sort In', 
        headerTooltip: 'Sort In', 
        tooltipValueGetter: params => 'Sort In : ' + params.value, 
        field: 'sortIn', 
        filter: 'agTextColumnFilter', 
        cellEditor: 'agSelectCellEditor', // Use agSelectCellEditor for dropdowns in Community version
          cellEditorParams: {
            values: ['ASC', 'DESC'], // Dropdown values
          },
        editable: true,
        width: 100 
      },
      { headerName: 'Label', 
        headerTooltip: 'Label', 
        tooltipValueGetter: params => 'Label : ' + params.value, 
        field: 'QSlabel', 
        filter: 'agTextColumnFilter', 
        cellEditor: 'agTextCellEditor', 
        editable: true,
        width: 150 
      },
      { headerName: 'Visibility', 
        headerTooltip: 'Visibility', 
        tooltipValueGetter: params => 'Visibility : ' + params.value, 
        field: 'visibility', 
        filter: 'agTextColumnFilter', 
        cellEditor: 'agSelectCellEditor', // Use agSelectCellEditor for dropdowns in Community version
          cellEditorParams: {
            values: ['VISIBLE', 'HIDDEN'], // Dropdown values
          },
        editable: true,
        width: 100 
      }
    ];
    this.columnDefsForSelectedValues= [
      {
        headerName: "Values",
        tooltipValueGetter: params => "Selected Attributes : " + params.value,
        field: "alias",
        filter: "agTextColumnFilter",
        width: 200,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellStyle: { " padding-left": "5px" },
        editable: true,
        rowDrag: true
      },
      { headerName: 'Aggregate', 
        headerTooltip: 'Aggregate', 
        tooltipValueGetter: params => 'Aggregate : ' + params.value, 
        field: 'vauleCountType', 
        filter: 'agTextColumnFilter', 
        cellEditor: 'agSelectCellEditor', // Use agSelectCellEditor for dropdowns in Community version
          cellEditorParams: {
            values: ['COUNT', 'DISTINCT_COUNT'], // Dropdown values
          },
        editable: true,
        width: 150 
      },
      { headerName: 'Label', 
        headerTooltip: 'Label', 
        tooltipValueGetter: params => 'Label : ' + params.value, 
        field: 'QSlabel', 
        filter: 'agTextColumnFilter', 
        cellEditor: 'agTextCellEditor', 
        editable: true,
        width: 150 
      },
      { headerName: 'Visibility', 
        headerTooltip: 'Visibility', 
        tooltipValueGetter: params => 'Visibility : ' + params.value, 
        field: 'visibility', 
        filter: 'agTextColumnFilter', 
        cellEditor: 'agSelectCellEditor', // Use agSelectCellEditor for dropdowns in Community version
          cellEditorParams: {
            values: ['VISIBLE', 'HIDDEN'], // Dropdown values
          },
        editable: true,
        width: 100 
      }

    ];
    this.columnDefsForSelectedColumns = [
      {
        headerName: "Columns",
        tooltipValueGetter: params => "Selected Attributes : " + params.value,
        field: "alias",
        filter: "agTextColumnFilter",
        width: 200,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellStyle: { " padding-left": "5px" },
        editable: true,
        rowDrag: true
      },
      { headerName: 'Sort In', 
        headerTooltip: 'Sort In', 
        tooltipValueGetter: params => 'Sort In : ' + params.value, 
        field: 'sortIn', 
        filter: 'agTextColumnFilter', 
        cellEditor: 'agSelectCellEditor', // Use agSelectCellEditor for dropdowns in Community version
          cellEditorParams: {
            values: ['ASC', 'DESC'], // Dropdown values
          },
        editable: true,
        width: 100 
      },
      { headerName: 'Label', 
        headerTooltip: 'Label', 
        tooltipValueGetter: params => 'Label : ' + params.value, 
        field: 'QSlabel', 
        filter: 'agTextColumnFilter', 
        cellEditor: 'agTextCellEditor', 
        editable: true,
        width: 150 
      },
      { headerName: 'Visibility', 
        headerTooltip: 'Visibility', 
        tooltipValueGetter: params => 'Visibility : ' + params.value, 
        field: 'visibility', 
        filter: 'agTextColumnFilter', 
        cellEditor: 'agSelectCellEditor', // Use agSelectCellEditor for dropdowns in Community version
          cellEditorParams: {
            values: ['VISIBLE', 'HIDDEN'], // Dropdown values
          },
        editable: true,
        width: 100 
      }
    ];
    this.sortingOrder = ["asc", "desc", null]
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };
    this.rowSelectionForTablesFields = 'multiple';

   this.formValidation()
    this.getDatasets()
    
  }
  
  formValidation() {
    this.validations_form = new UntypedFormGroup({
      selectdataSet: new UntypedFormControl('', [Validators.required]),
      visualName: new UntypedFormControl('', [Validators.required,this.validation.specialCharacterValidator]),
      selectVisualType: new UntypedFormControl('', [Validators.required]),
      // selectAttribute: new UntypedFormControl('', [Validators.required]),
      // selectColumnType: new UntypedFormControl('', [Validators.required]),
      // selectAggregationType: new UntypedFormControl('')

    });
  }

  onCheckboxChanged(params: any) {
    console.log(params);
    
    // const newValue = !params.data[params.colDef.field]; // Toggle the checkbox value
    // params.node.setDataValue(params.colDef.field, newValue);
    // console.log(this.dataSetObject.columns);
    
  }
  searchableDatasetsOnInsert(){
    if(!this.data.editData){
    if(this.getDataSetData.length > 0){
      var columndata = []
    var c = {
      "datasetname": "Dataset Name",
      "type":"Type",
      "datasetObjectname":"Object Name",
      "description":"Description",
      "objectGroup":"Object Group"
    }
   columndata.push(c)
   
    let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
      width: "70%",
      autoFocus: false,
      data: { 
        edata:this.getDataSetData,
        page:"single",
        columns:columndata,
        selectedValue:[this.dataSetObject.datasetId],
        selectedPropertyName:"reportcreationid"
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result != undefined) {
        this.selectedDataset=result.selectedRows[0]
        this.selectedRowsData=[]
        this.selectedColumnsData=[]
        this.selectedValuesData=[]
        this.visualObjectList=[]
        this.sortByList=[]
        this.dataSetObject.columns=[]
        this.dataSetObject.concatination=[]
        this.dataSetObject.aggregate=[]
        this.dataSetObject.rollingUp=[]
        this.selectedDatasetObject=result.selectedRows[0]
        this.dataSetObject.datasetId = result.selectedRows[0].reportcreationid;
        this.dataSetObject.datasetName = result.selectedRows[0].datasetname;

        this.dataSetObject.columns=JSON.parse(result.selectedRows[0].columns);
        this.dataSetObject.columns.forEach(obj => {
          obj.showInVisual = false;
          obj.sortBy = false;
          obj.sortIn="ASC";
          obj.QSlabel=""
          obj.visibility="VISIBLE"
        
        });
        this.dataSetObject.concatination=JSON.parse(result.selectedRows[0].concatination)
        this.dataSetObject.concatination.forEach(obj => {
          
          obj.showInVisual = false;
          obj.sortBy = false;
          obj.sortIn="ASC";
          obj.QSlabel=""
          obj.visibility="VISIBLE"
        });
        this.dataSetObject.aggregate=JSON.parse(result.selectedRows[0].aggregate)
        this.dataSetObject.aggregate.forEach(obj => {
          obj.showInVisual = false;
          obj.sortBy = false;
          obj.sortIn="ASC";
          obj.QSlabel=""
          obj.visibility="VISIBLE"
         
        });
        
        this.dataSetObject.rollingUp=JSON.parse(result.selectedRows[0].rollingUp)
        this.dataSetObject.rollingUp.forEach(obj => {
          obj.showInVisual = false;
          obj.sortBy = false;
          obj.sortIn="ASC";
          obj.QSlabel=""
          obj.visibility="VISIBLE"
        });

        console.log(this.dataSetObject.columns);
        
        this.tabularParams.setGridOption('rowData', this.dataSetObject.columns)
        this.tabularconcatinationParams.setGridOption('rowData', this.dataSetObject.concatination)
        this.tabularaggregateParams.setGridOption('rowData', this.dataSetObject.aggregate)
        this.tabularrollingUpParams.setGridOption('rowData', this.dataSetObject.rollingUp)
      }
    })
    }
  }
  }
  searchableDatasets(result,visualConfig) {
    if(this.getDataSetData.length > 0){
      console.log(result);
      
      
  //   var columndata = []
  //   var c = {
  //     "datasetname": "Dataset Name",
  //     "type":"Type",
  //     "datasetObjectname":"Object Name",
  //     "description":"Description",
  //     "objectGroup":"Object Group"
  //   }
  //  columndata.push(c)
   
  //   let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
  //     width: "70%",
  //     autoFocus: false,
  //     data: { 
  //       edata:this.getDataSetData,
  //       page:"single",
  //       columns:columndata,
  //       selectedValue:[this.dataSetObject.datasetId],
  //       selectedPropertyName:"reportcreationid"
  //     }
  //   });

    // dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      
      this.tableProperties ={
        title:"",
        subTitle:"",
        layout:"TABULAR",
        valuesPosition:"",
        totalOptionsRowChecked:false,
        totalOptionsColumnsChecked:false,
        subtotalOptionsRowChecked:false,
        subtotalOptionsColumnsChecked:false,
        rowsTotal:{
          label:"Total",
          position:"Bottom"
        },
        columnsTotal:{
          label:"Total",
          position:"Bottom"
        },
        rowsSubTotal:{
          label:"Subtotal",
          level:"",
          customAttributesSelected:[]
        },
        columnsSubTotal:{ 
          label:"Subtotal",
          level:"",
          customAttributesSelected:[]
        },
        headers:{
          rowsLabel:"",
          visibility:"VISIBLE"
        },
        visualConfig:[]
      }
      if (result != undefined) {
        this.selectedDataset=result
        this.selectedRowsData=[]
        this.selectedColumnsData=[]
        this.selectedValuesData=[]
        this.visualObjectList=[]
        this.sortByList=[]
        this.dataSetObject.columns=[]
        this.dataSetObject.concatination=[]
        this.dataSetObject.aggregate=[]
        this.dataSetObject.rollingUp=[]
        this.selectedDatasetObject=result[0]
        // this.dataSetObject.datasetId = result[0].reportcreationid;
        this.dataSetObject.datasetName = result[0].datasetname;
        // console.log(result.map(item => item.alias));
        console.log(result);
        
        
       
        
        if(this.dataSetObject.visualType == 'Pivot'){
          this.dataSetObject.columns.push(...JSON.parse(result[0].columns));
          this.dataSetObject.columns.push(...JSON.parse(result[0].concatination));
          this.dataSetObject.columns.push(...JSON.parse(result[0].aggregate));
          let roolingUp = JSON.parse(result[0].rollingUp)
          roolingUp.forEach(obj => {
              obj.alias=obj.rollupColumnAlias
          });
          this.dataSetObject.columns.push(...roolingUp);
          this.dataSetObject.columns.forEach(obj => {
            if(obj.showInVisual){
              obj.showInVisual=obj.showInVisual
            }else{
              obj.showInVisual = false;
            }
            if(obj.sortBy){
              obj.sortBy=obj.sortBy
            }else{
              obj.sortBy = false;
            }
            obj.sortIn="ASC";
            obj.QSlabel=""
            obj.visibility="VISIBLE"
          });
        this.tableProperties = JSON.parse(visualConfig);
        if(!this.tableProperties.rowsSubTotal){
          this.tableProperties.subtotalOptionsRowChecked=false;
          this.tableProperties.rowsSubTotal={
            label:"Subtotal",
            level:"",
            customAttributesSelected:[]
          }
          
        }
        if(!this.tableProperties.columnsSubTotal){
          this.tableProperties.subtotalOptionsColumnsChecked=false;
          this.tableProperties.columnsSubTotal={ 
            label:"Subtotal",
            level:"",
            customAttributesSelected:[]
          }
        }
        if(!this.tableProperties.headers){
          this.tableProperties.headers={
            rowsLabel:"",
            visibility:"VISIBLE"
          }
        }
        console.log(this.tableProperties);
        
        this.dataSetObject.visualConfig=this.tableProperties.visualConfig
        if(this.dataSetObject.visualConfig && this.dataSetObject.visualConfig.length > 0){
          for(let i=0;i<this.dataSetObject.visualConfig.length;i++){
            if(this.dataSetObject.visualConfig[i].columnType == "rows"){
              let rowObject = this.dataSetObject.columns.filter(obj=> obj.alias == this.dataSetObject.visualConfig[i].columnName)
              if(rowObject.length > 0){
                rowObject[0].sortIn=this.dataSetObject.visualConfig[i].sortIn;
                rowObject[0].QSlabel=this.dataSetObject.visualConfig[i].QSlabel
                rowObject[0].visibility=this.dataSetObject.visualConfig[i].visibility
                console.log(rowObject);
                this.selectedRowsData.push(rowObject[0])
              }
             
            }
            if(this.dataSetObject.visualConfig[i].columnType == "columns"){
              let rowObject = this.dataSetObject.columns.filter(obj=> obj.alias == this.dataSetObject.visualConfig[i].columnName)
              if(rowObject.length > 0){
                rowObject[0].sortIn=this.dataSetObject.visualConfig[i].sortIn;
                rowObject[0].QSlabel=this.dataSetObject.visualConfig[i].QSlabel
                rowObject[0].visibility=this.dataSetObject.visualConfig[i].visibility
                console.log(rowObject);
                this.selectedColumnsData.push(rowObject[0])
              }
            }
            if(this.dataSetObject.visualConfig[i].columnType == "values"){
              let valuesData = this.dataSetObject.columns.filter(obj=> obj.alias == this.dataSetObject.visualConfig[i].columnName)[0]
              valuesData["vauleCountType"] = this.dataSetObject.visualConfig[i].vauleCountType;
             valuesData["sortIn"]=this.dataSetObject.visualConfig[i].sortIn;
             valuesData["QSlabel"]=this.dataSetObject.visualConfig[i].QSlabel
             valuesData["visibility"]=this.dataSetObject.visualConfig[i].visibility
              this.selectedValuesData.push(valuesData)
            }
            if(this.dataSetObject.visualConfig[i].sortBy){
              this.sortByList.push(this.dataSetObject.visualConfig[i].columnName)
            }
          }
          this.visualObjectList = this.dataSetObject.visualConfig
          this.showList=true;
        }else{
          this.visualObjectList =[];
          this.showList=false;
          this.visualObject={
            columnName:"",
            columnType:"",
            vauleCountType:"",
            sortBy:false
          }
      
          // this.validations_form.get('selectAttribute').reset();
          // this.validations_form.get('selectColumnType').reset();
          // this.validations_form.get('selectAggregationType').reset();
        }
        this.paramstemp.api.setGridOption('rowData', this.dataSetObject.columns);
        this.selectedTableFields.api.setGridOption('rowData', this.selectedRowsData)
        this.selectedColumns.api.setGridOption('rowData', this.selectedColumnsData)
        this.selectedValues.api.setGridOption('rowData', this.selectedValuesData)
        // this.onGridReadyForTablesFields(this.paramstemp,this.dataSetObject.columns)
        // this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.selectedRowsData);
        // this.onGridReadyForColumns(this.selectedColumns, this.selectedColumnsData);
        // this.onGridReadyForValues(this.selectedValues, this.selectedValuesData);
      }else{
        this.selectedRowsData=[]
        this.selectedColumnsData=[]
        this.selectedValuesData=[]
       
        // this.tabularParams.setGridOption('rowData', this.dataSetObject.columns);
        if(this.dataSetObject.visualType != 'Pivot'){
console.log(JSON.parse(visualConfig));

          let visualConfigData=JSON.parse(visualConfig)
          console.log(JSON.parse(result[0].concatination));
          this.dataSetObject.columns=JSON.parse(result[0].columns);
        
          this.dataSetObject.columns.forEach(obj => {
            let configObject = visualConfigData.filter(config => config.alias == obj.alias)
            if(configObject.length>0){
              obj.showInVisual=true
              obj.sortBy=configObject[0].sortBy
              if(configObject[0].QSlabel){
                obj.QSlabel=configObject[0].QSlabel
              }else{
                obj.QSlabel=""
              }
              if(configObject[0].visibility){
                obj.visibility=configObject[0].visibility
              }else{
                obj.visibility="VISIBLE"
              }
            }
          });
          
          this.dataSetObject.concatination=JSON.parse(result[0].concatination)
          this.dataSetObject.concatination.forEach(obj => {
            let configObject = visualConfigData.filter(config => config.alias == obj.alias)
            if(configObject.length>0){
              obj.showInVisual=true
              obj.sortBy=configObject[0].sortBy
              if(configObject[0].QSlabel){
                obj.QSlabel=configObject[0].QSlabel
              }else{
                obj.QSlabel=""
              }
              if(configObject[0].visibility){
                obj.visibility=configObject[0].visibility
              }else{
                obj.visibility="VISIBLE"
              }
            }
          });
          
          this.dataSetObject.aggregate=JSON.parse(result[0].aggregate)
          this.dataSetObject.aggregate.forEach(obj => {
            let configObject = visualConfigData.filter(config => config.alias == obj.alias)
            if(configObject.length>0){
              obj.showInVisual=true
              obj.sortBy=configObject[0].sortBy
              if(configObject[0].QSlabel){
                obj.QSlabel=configObject[0].QSlabel
              }else{
                obj.QSlabel=""
              }
              if(configObject[0].visibility){
                obj.visibility=configObject[0].visibility
              }else{
                obj.visibility="VISIBLE"
              }
            }
          });
          
          this.dataSetObject.rollingUp=JSON.parse(result[0].rollingUp)
          
          this.dataSetObject.rollingUp.forEach(obj => {
            let configObject = visualConfigData.filter(config => config.alias == obj.alias)
            if(configObject.length>0){
              obj.showInVisual=true
              obj.sortBy=configObject[0].sortBy
              if(configObject[0].QSlabel){
                obj.QSlabel=configObject[0].QSlabel
              }else{
                obj.QSlabel=""
              }
              if(configObject[0].visibility){
                obj.visibility=configObject[0].visibility
              }else{
                obj.visibility="VISIBLE"
              }
            }
          });
          this.tabularParams.setGridOption('rowData', this.dataSetObject.columns)
          for(let i=0;i<this.dataSetObject.columns.length;i++){
            if(this.dataSetObject.columns[i].showInVisual){
              this.tabularParams.forEachNode(node=>{
                if(node.data["alias"]== this.dataSetObject.columns[i].alias){
                     node.setSelected(true)
                }
              })
            }
          }
          this.tabularconcatinationParams.setGridOption('rowData', this.dataSetObject.concatination)
         
          // FOR CONCATINATION TO SELECT VALUES IN TABLE
          for(let i=0;i<this.dataSetObject.concatination.length;i++){
            if(this.dataSetObject.concatination[i].showInVisual){
              this.tabularconcatinationParams.forEachNode(node=>{
                if(node.data["alias"]== this.dataSetObject.concatination[i].alias){
                     node.setSelected(true)
                }
              })
            }
          }
          this.tabularaggregateParams.setGridOption('rowData', this.dataSetObject.aggregate)
         
          // FOR AGGREGATE TO SELECT VALUES IN TABLE
          for(let i=0;i<this.dataSetObject.aggregate.length;i++){
            if(this.dataSetObject.aggregate[i].showInVisual){
              this.tabularaggregateParams.forEachNode(node=>{
                if(node.data["alias"]== this.dataSetObject.aggregate[i].alias){
                     node.setSelected(true)
                }
              })
            }
          }
          this.tabularrollingUpParams.setGridOption('rowData', this.dataSetObject.rollingUp)

          // FOR ROLLING UP TO SELECT VALUES IN TABLE
          for(let i=0;i<this.dataSetObject.aggregate.length;i++){
            if(this.dataSetObject.aggregate[i].showInVisual){
              this.tabularrollingUpParams.forEachNode(node=>{
                if(node.data["rollupColumnAlias"]== this.dataSetObject.aggregate[i].rollupColumnAlias){
                     node.setSelected(true)
                }
              })
            }
          }
        }
        
      }
      
       
       
      }
    // });

   }
  }

  
  searchableRows() {
    if(this.getDataSetData.length > 0){
      
    var columndata = []
    var c = {
      "alias": "Alias",
      "label":"Label",
      "name":"Name",
      "object":"Object",
      "objectLabel":"Object Label"
    }
   columndata.push(c)
   
    let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
      width: "70%",
      autoFocus: false,
      data: { 
        edata:this.dataSetObject.columns,
        page:"single",
        columns:columndata,
        selectedValue:[this.visualObject.columnName],
        selectedPropertyName:"alias"
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.visualObject.columnName= result.selectedRows.map(item => item.alias)[0]
        
      }
    });

   }
  }
  getDatasets(){
    this.spinner.start();
    this.linkservice.retrievereport(this.localStorageSettings.getSettings("UserId"), this.localStorageSettings.getSettings("dnsName"), this.localStorageSettings.getSettings("AuthUsername")).subscribe(response =>{
      if (response.error == true) {
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
      } else {
        this.getDataSetData=response;
        this.spinner.stop();
        if(this.data.editData){
          this.buttonName="Update"
          this.existingData=this.data.editData
          console.log(this.existingData);
          this.dataSetObject.datasetId=this.existingData.datasetId
          this.dataSetObject.visualType=this.existingData.visualType
         
          this.visualName=this.existingData.visualName
          this.validations_form.get("selectdataSet").setValue(this.dataSetObject.datasetName)
          if(this.getDataSetData.length > 0){
            this.searchableDatasets(this.getDataSetData.filter(dataset=>dataset.reportcreationid == this.dataSetObject.datasetId),this.existingData.visualConfig)
          }
        }else{
           this.buttonName="Save"
        }
       
      }
    })
  }
  createJsonForSelectedRows(){
    
    this.visualObjectList=[]
    for(let i=0;i<this.selectedRowsData.length;i++){
      let rowObject ={
        columnName:this.selectedRowsData[i].alias,
        columnType:"rows",
        vauleCountType:"",
        sortBy:false,
        sortIn:this.selectedRowsData[i].sortIn,
        QSlabel:this.selectedRowsData[i].QSlabel,
        visibility:this.selectedRowsData[i].visibility,
        type:this.selectedRowsData[i].type
      }
      if(this.sortByList.filter(obj=>obj == this.selectedRowsData[i].alias).length > 0){
        rowObject.sortBy=true;
      }
      this.visualObjectList.push(rowObject)
    }
    for(let i=0;i<this.selectedColumnsData.length;i++){
      let columnObject ={
        columnName:this.selectedColumnsData[i].alias,
        columnType:"columns",
        vauleCountType:"",
        sortBy:false,
        sortIn:this.selectedColumnsData[i].sortIn,
        QSlabel:this.selectedColumnsData[i].QSlabel,
        visibility:this.selectedColumnsData[i].visibility,
        type:this.selectedColumnsData[i].type
      }
      if(this.sortByList.filter(obj=>obj == this.selectedColumnsData[i].alias).length > 0){
        columnObject.sortBy=true;
      }
      this.visualObjectList.push(columnObject)
    }
    for(let i=0;i<this.selectedValuesData.length;i++){
      let valueObject ={
        columnName:this.selectedValuesData[i].alias,
        columnType:"values",
        vauleCountType:this.selectedValuesData[i].vauleCountType,
        sortBy:false,
        sortIn:this.selectedValuesData[i].sortIn,
        QSlabel:this.selectedValuesData[i].QSlabel,
        visibility:this.selectedValuesData[i].visibility,
        type:this.selectedValuesData[i].type
      }
      if(this.sortByList.filter(obj=>obj == this.selectedValuesData[i].alias).length > 0){
        valueObject.sortBy=true;
      }
      this.visualObjectList.push(valueObject)
    }
    
  }
  sendDataAndClose(){
    console.log(this.dataSetObject.columns);
    if (!this.validations_form.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.validations_form);

      this.validation.getvalidationmessage();

    } else {
    let object
    if(this.buttonName == "Save"){
      object={
        "datasetId":this.dataSetObject.datasetId,
        "visualConfig":"",
        "visualType":this.dataSetObject.visualType,
        "visualName":this.visualName
      }
    }else{
      object={
        "visualId":this.existingData.visualId,
        "datasetId":this.dataSetObject.datasetId,
        "visualConfig":"",
        "visualType":this.dataSetObject.visualType,
        "visualName":this.visualName,
        
      }
    }
    
    if(this.dataSetObject.visualType == 'Pivot'){
    this.createJsonForSelectedRows()
    
    this.tableProperties.visualConfig=this.visualObjectList;
    console.log(this.visualObjectList);
    
    object.visualConfig=JSON.stringify(this.tableProperties)
    if(this.visualObjectList.length > 0){
      this.visualServices.createManageVisuals(object).subscribe(response=>{
        if (response.error == true) {
          this.spinner.stop();
          this.snackbar.open(response.statusMessage, "OK", {
            duration: 5000,
          });
        } else {
          this.spinner.stop();
          if(this.buttonName == "Save"){
            this.snackbar.open(response.statusMessage, "OK", {
              duration: 5000,
            });
          }else{
            this.snackbar.open("Successfully Updated", "OK", {
              duration: 5000,
            });
          }
         
          this.closeFunction();
        }
      })
    }else{
      this.snackbar.open("Can't create empty visuals, Please select at least one attribute", "OK", {
        duration: 5000,
      });
    }
  }else{
   
    // this.spinner.start();
    console.log(this.dataSetObject.columns);
    console.log(this.dataSetObject.concatination);
    console.log(this.dataSetObject.aggregate);
    console.log(this.dataSetObject.rollingUp);

    let tabularSelectedData=[]

    tabularSelectedData.push(...this.dataSetObject.columns.filter(column=>
      column.showInVisual==true
    ))
    tabularSelectedData.push(...this.dataSetObject.concatination.filter(column=>
      column.showInVisual==true
    ))
    tabularSelectedData.push(...this.dataSetObject.aggregate.filter(column=>
      column.showInVisual==true
    ))
    tabularSelectedData.push(...this.dataSetObject.rollingUp.filter(column=>
      column.showInVisual==true
    ))
    object.visualConfig=JSON.stringify(tabularSelectedData)
    if(tabularSelectedData.length > 0){
      this.visualServices.createManageVisuals(object).subscribe(response=>{
        if (response.error == true) {
          this.spinner.stop();
          this.snackbar.open(response.statusMessage, "OK", {
            duration: 5000,
          });
        } else {
          this.spinner.stop();
          if(this.buttonName == "Save"){
            this.snackbar.open(response.statusMessage, "OK", {
              duration: 5000,
            });
          }else{
            this.snackbar.open("Successfully Updated", "OK", {
              duration: 5000,
            });
          }
          this.closeFunction();
        }
      })
    }else{
      this.snackbar.open("Can't create empty visuals, Please select at least one attribute", "OK", {
        duration: 5000,
      });
    }
  }
}
  }

  closeFunction(){
    this.dialogref.close(null)
  }

 

  onAttributeTypeChange(event){
    if(event == "values"){
      this.validations_form.get('selectAggregationType').setValidators([Validators.required])
    }else{
      this.validations_form.get('selectAggregationType').reset();
      this.validations_form.get('selectAggregationType').clearValidators();
    }
  }

  deleteWhere(k) {
    this.visualObjectList.splice(k, 1);
    if (this.visualObjectList.length == 0) {
      this.showList = false;
    }
  }
  onTabularShowInVisualsSelected(event){
    console.log(event.rowIndex);
    console.log(event);
    
    if(event.node.isSelected()){
      this.dataSetObject.columns[event.node.id]["showInVisual"]=true
      console.log(this.dataSetObject.columns);
      
    }else{
      this.dataSetObject.columns[event.node.id]["showInVisual"]=false
    }
    this.tabularParams.refreshCells({ force: true });
  }

  // FOR CONCATINATION
  onTabularConcatinationShowInVisualsSelected(event){
    console.log(event.rowIndex);
    console.log(event);
    
    if(event.node.isSelected()){
      this.dataSetObject.concatination[event.node.id]["showInVisual"]=true
    }else{
      this.dataSetObject.concatination[event.node.id]["showInVisual"]=false
    }
    this.tabularconcatinationParams.refreshCells({ force: true });
  }

  // FOR AGGREGATE
  onTabularAggregateShowInVisualsSelected(event){
    console.log(event.rowIndex);
    console.log(event);
    
    if(event.node.isSelected()){
      this.dataSetObject.aggregate[event.node.id]["showInVisual"]=true
    }else{
      this.dataSetObject.aggregate[event.node.id]["showInVisual"]=false
    }
    this.tabularrollingUpParams.refreshCells({ force: true });
  }

  // FOR ROLLING UP
  onTabularRollingShowInVisualsSelected(event){
    console.log(event.rowIndex);
    console.log(event);
    
    if(event.node.isSelected()){
      this.dataSetObject.rollingUp[event.node.id]["showInVisual"]=true
    }else{
      this.dataSetObject.rollingUp[event.node.id]["showInVisual"]=false
    }
    this.tabularaggregateParams.refreshCells({ force: true });
  }

  onRowSelected(event) {
    this.selectedFieldsData = this.paramstemp.api.getSelectedRows();
  }
  onRowSelectedToRemoveRows(event){
    this.selectedRowsDataToRemove=this.selectedTableFields.api.getSelectedRows();
   
  }
  onRowSelectedToRemoveColumns(event){
    this.selectedColumnsDataToRemove=this.selectedColumns.api.getSelectedRows();
  }
  onRowSelectedToRemoveValues(event){
  this.selectedValuesDataToRemove=this.selectedValues.api.getSelectedRows();
  }

  removeSelectedRowData(){
    this.selectedRowsData = this.selectedRowsData.filter(obj1 => !this.selectedRowsDataToRemove.some(obj2 => obj1.alias === obj2.alias));
    this.createJsonForSelectedRows()
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.selectedRowsData);
    this.selectedTableFields.api.deselectAll();
  }
  removeSelectedColumnData(){
    this.selectedColumnsData = this.selectedColumnsData.filter(obj1 => !this.selectedColumnsDataToRemove.some(obj2 => obj1.alias === obj2.alias));
    this.createJsonForSelectedRows()
    this.onGridReadyForColumns(this.selectedColumns, this.selectedColumnsData);
    this.selectedColumns.api.deselectAll();
  }
  removeSelectedValueData(){
    this.selectedValuesData = this.selectedValuesData.filter(obj1 => !this.selectedValuesDataToRemove.some(obj2 => obj1.alias === obj2.alias));
    this.createJsonForSelectedRows()
    this.onGridReadyForValues(this.selectedValues, this.selectedValuesData);
    this.selectedValues.api.deselectAll();
  }
  onGridReadyForTablesFields(params, tableName) {
   if(params != undefined){
    this.paramstemp = params;
    this.paramstemp.api.setGridOption('rowData', this.dataSetObject.columns);
   }
   
  }
  onGridReadyForTabularFields(params, tableName) {
    if(params != undefined){
     this.tabularParams = params.api;
     this.tabularParams.setGridOption('rowData', this.dataSetObject.columns);
     if(this.dataSetObject.visualType != 'Pivot'){
     for(let i=0;i<this.dataSetObject.columns.length;i++){
       if(this.dataSetObject.columns[i].showInVisual){
         this.tabularParams.forEachNode(node=>{
           if(node.data["alias"]== this.dataSetObject.columns[i].alias){
                node.setSelected(true)
           }
         })
       }
       
     }
   }
    }
    
   }

  //  FOR CONCATINATION
   onGridReadyForTabularConcatinationFields(params, tableName) {
    if(params != undefined){
     this.tabularconcatinationParams = params.api;
     this.tabularconcatinationParams.setGridOption('rowData', this.dataSetObject.concatination);
     if(this.dataSetObject.visualType != 'Pivot'){
     for(let i=0;i<this.dataSetObject.concatination.length;i++){
       if(this.dataSetObject.concatination[i].showInVisual){
         this.tabularconcatinationParams.forEachNode(node=>{
           if(node.data["alias"]== this.dataSetObject.concatination[i].alias){
                node.setSelected(true)
           }
         })
       }
       
     }
   }
    }
    
}

//  FOR AGGREATE
onGridReadyForTabularAggregateFields(params, tableName) {
  if(params != undefined){
   this.tabularaggregateParams = params.api;
   this.tabularaggregateParams.setGridOption('rowData', this.dataSetObject.aggregate);
   if(this.dataSetObject.visualType != 'Pivot'){
   for(let i=0;i<this.dataSetObject.aggregate.length;i++){
     if(this.dataSetObject.aggregate[i].showInVisual){
       this.tabularaggregateParams.forEachNode(node=>{
         if(node.data["alias"]== this.dataSetObject.aggregate[i].alias){
              node.setSelected(true)
         }
       })
     }
     
   }
 }
  }
  
}
//  FOR ROLLING UP
onGridReadyForTabularRollingFields(params, tableName) {
  if(params != undefined){
   this.tabularrollingUpParams = params.api;
   this.tabularrollingUpParams.setGridOption('rowData', this.dataSetObject.rollingUp);
   if(this.dataSetObject.visualType != 'Pivot'){
   for(let i=0;i<this.dataSetObject.rollingUp.length;i++){
     if(this.dataSetObject.rollingUp[i].showInVisual){
       this.tabularrollingUpParams.forEachNode(node=>{
         if(node.data["rollupColumnAlias"]== this.dataSetObject.rollingUp[i].rollupColumnAlias){
              node.setSelected(true)
         }
       })
     }
     
   }
 }
  }
  
}
  onGridReadyForSelectedTableFields(params, tableName) {
    this.selectedTableFields = params
    this.selectedTableFields.api.setGridOption('rowData', this.selectedRowsData);

  }
  onGridReadyForColumns(params, tableName){
    this.selectedColumns=params
    this.selectedColumns.api.setGridOption('rowData', this.selectedColumnsData);
  }
  onGridReadyForValues(params, tableName){
    this.selectedValues=params
    this.selectedValues.api.setGridOption('rowData', this.selectedValuesData);
  }
  onCellEditingStarted(event) {
    console.log(event);
    
    // this.previousAlias = this.replaceCharecter(event.data.attributeNameWithFields, ".", "_");
    // console.log(event.data.attributeNameWithFields);
  }
  onRowSelectedToRemove(ev) {
    console.log(ev);
    
  }
  pushDataToSelectedFieldsGrid(event){
    let uniq = {}
    if(this.selectedRowsData.length == 0){
      this.selectedRowsData = this.selectedFieldsData
    }else{
      this.selectedRowsData.push(...this.selectedFieldsData)
      this.selectedRowsData=this.selectedRowsData.filter(obj => !uniq[obj.alias] && (uniq[obj.alias] = true));
    }
    console.log(this.selectedRowsData);
    
    this.createJsonForSelectedRows()
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.selectedRowsData)
    this.paramstemp.api.deselectAll();
  }

  pushDataToColumnsGrid(event){
    // 
    let uniq = {}
    if(this.selectedColumnsData.length == 0){
      this.selectedColumnsData = this.selectedFieldsData
    }else{
      this.selectedColumnsData.push(...this.selectedFieldsData)
      this.selectedColumnsData=this.selectedColumnsData.filter(obj => !uniq[obj.alias] && (uniq[obj.alias] = true));
    }
    this.createJsonForSelectedRows()
    this.onGridReadyForColumns(this.selectedColumns, this.selectedColumnsData)
    this.paramstemp.api.deselectAll();
  }

  pushDataToValuesGrid(event){
    // 
    let uniq = {}
    this.selectedFieldsData.forEach(item => {
      item["vauleCountType"] = "COUNT";
    });
    if(this.selectedValuesData.length == 0){
      this.selectedValuesData = this.selectedFieldsData
    }else{
      this.selectedValuesData.push(...this.selectedFieldsData)
      this.selectedValuesData=this.selectedValuesData.filter(obj => !uniq[obj.alias] && (uniq[obj.alias] = true));
    }
    this.createJsonForSelectedRows()
    this.onGridReadyForValues(this.selectedValues, this.selectedValuesData)
    this.paramstemp.api.deselectAll();
  }
  onRowDragEnter(e: RowDragEnterEvent) {
    console.log('onRowDragEnter', e);

  }

  onRowDragEnd(event) {
    const draggedRowData = event.node.data;
    const sourceGrid = event.api;
    const targetGrid = event.overNode?.gridOptionsWrapper?.gridOptions?.api;

    if (targetGrid && targetGrid !== sourceGrid) {
      // Remove row from the source grid
      const sourceRowData = [];
      sourceGrid.forEachNode((node: any) => {
        if (node.id !== event.node.id) {
          sourceRowData.push(node.data);
        }
      });
      sourceGrid.setGridOption('rowData', sourceRowData);

      // Add row to the target grid
      const targetRowData = targetGrid.getDisplayedRowCount() > 0 ? targetGrid.getDisplayedRowData() : [];
      targetRowData.push(draggedRowData);
      targetGrid.setGridOption('rowData', targetRowData);
    }
   

  }

  onRowDragMove(e: RowDragMoveEvent) {
    console.log('onRowDragMove', e);
  }

  onRowDragLeave(e: RowDragLeaveEvent) {
    console.log('onRowDragLeave', e);
  }

  onCellValueChanged(e) {
    console.log(e)
    // this.selectedTableFields.api.deselectAll();
    // this.changealisaname(e)
  }

  togglePanel(panel: string): void {
    this.openPanels[panel] = !this.openPanels[panel];
  }

  onVisualTypeChange(event){
    this.dataSetObject.columns=[]
    this.dataSetObject.concatination=[]
    this.dataSetObject.aggregate=[]
    this.dataSetObject.rollingUp=[]
    if(this.dataSetObject.visualType == 'Pivot'){
      console.log(this.selectedDataset);
      
      this.dataSetObject.columns.push(...JSON.parse(this.selectedDataset.columns));
      this.dataSetObject.columns.push(...JSON.parse(this.selectedDataset.concatination));
      this.dataSetObject.columns.push(...JSON.parse(this.selectedDataset.aggregate));
      let roolingUp = JSON.parse(this.selectedDataset.rollingUp)
      roolingUp.forEach(obj => {
          obj.alias=obj.rollupColumnAlias
      });
      this.dataSetObject.columns.push(...roolingUp);
      this.dataSetObject.columns.forEach(obj => {
        obj.showInVisual = false;
        obj.sortBy = false;
        obj.sortIn="ASC";
        obj.QSlabel="";
        obj.visibility="VISIBLE"
      
      });
  //   if(this.selectedDataset.visualConfig){
  //   this.tableProperties = JSON.parse(this.selectedDataset.visualConfig);
  //   if(!this.tableProperties.rowsSubTotal){
  //     this.tableProperties.subtotalOptionsRowChecked=false;
  //     this.tableProperties.rowsSubTotal={
  //       label:"Subtotal",
  //       level:"",
  //       customAttributesSelected:[]
  //     }
      
  //   }
  //   if(!this.tableProperties.columnsSubTotal){
  //     this.tableProperties.subtotalOptionsColumnsChecked=false;
  //     this.tableProperties.columnsSubTotal={ 
  //       label:"Subtotal",
  //       level:"",
  //       customAttributesSelected:[]
  //     }
  //   }
  //   console.log(this.tableProperties);
    
  //   this.dataSetObject.visualConfig=this.tableProperties.visualConfig
  //   if(this.dataSetObject.visualConfig && this.dataSetObject.visualConfig.length > 0){
  //     for(let i=0;i<this.dataSetObject.visualConfig.length;i++){
  //       if(this.dataSetObject.visualConfig[i].columnType == "rows"){
  //         this.selectedRowsData.push(this.dataSetObject.columns.filter(obj=> obj.alias == this.dataSetObject.visualConfig[i].columnName)[0])
  //       }
  //       if(this.dataSetObject.visualConfig[i].columnType == "columns"){
  //         this.selectedColumnsData.push(this.dataSetObject.columns.filter(obj=> obj.alias == this.dataSetObject.visualConfig[i].columnName)[0])
  //       }
  //       if(this.dataSetObject.visualConfig[i].columnType == "values"){
  //         let valuesData = this.dataSetObject.columns.filter(obj=> obj.alias == this.dataSetObject.visualConfig[i].columnName)[0]
  //         valuesData["vauleCountType"] = this.dataSetObject.visualConfig[i].vauleCountType;
  //         this.selectedValuesData.push(valuesData)
  //       }
  //       if(this.dataSetObject.visualConfig[i].sortBy){
  //         this.sortByList.push(this.dataSetObject.visualConfig[i].columnName)
  //       }
  //     }
  //     this.visualObjectList = this.dataSetObject.visualConfig
  //     this.showList=true;
  //   }else{
  //     this.visualObjectList =[];
  //     this.showList=false;
  //     this.visualObject={
  //       columnName:"",
  //       columnType:"",
  //       vauleCountType:"",
  //       sortBy:false
  //     }
  
  //     this.validations_form.get('selectAttribute').reset();
  //     this.validations_form.get('selectColumnType').reset();
  //     this.validations_form.get('selectAggregationType').reset();
  //   }
  //   this.paramstemp.api.setGridOption('rowData', this.dataSetObject.columns);
  //   this.selectedTableFields.api.setGridOption('rowData', this.selectedRowsData)
  //   this.selectedColumns.api.setGridOption('rowData', this.selectedColumnsData)
  //   this.selectedValues.api.setGridOption('rowData', this.selectedValuesData)
  //   // this.onGridReadyForTablesFields(this.paramstemp,this.dataSetObject.columns)
  //   // this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.selectedRowsData);
  //   // this.onGridReadyForColumns(this.selectedColumns, this.selectedColumnsData);
  //   // this.onGridReadyForValues(this.selectedValues, this.selectedValuesData);
  // }
  }else{
    this.selectedRowsData=[]
    this.selectedColumnsData=[]
    this.selectedValuesData=[]
   
    // this.tabularParams.setGridOption('rowData', this.dataSetObject.columns);
    if(this.dataSetObject.visualType != 'Pivot'){

      console.log(JSON.parse(this.selectedDataset.concatination));
      this.dataSetObject.columns=JSON.parse(this.selectedDataset.columns);
    console.log(this.dataSetObject.columns);
    
      this.dataSetObject.columns.forEach(obj => {
        obj.showInVisual = false;
          obj.sortBy = false;
          if(obj.QSlabel){
            obj.QSlabel=obj.QSlabel
          }else{
            obj.QSlabel=""
          }
          if(obj.visibility){
            obj.visibility=obj.visibility
          }else{
            obj.visibility="VISIBLE"
          }
      
      });
      
      this.dataSetObject.concatination=JSON.parse(this.selectedDataset.concatination)
      this.dataSetObject.concatination.forEach(obj => {
        obj.showInVisual = false;
        obj.sortBy = false;
        if(obj.QSlabel){
          obj.QSlabel=obj.QSlabel
        }else{
          obj.QSlabel=""
        }
        if(obj.visibility){
          obj.visibility=obj.visibility
        }else{
          obj.visibility="VISIBLE"
        }
      });
      this.dataSetObject.aggregate=JSON.parse(this.selectedDataset.aggregate)
      this.dataSetObject.aggregate.forEach(obj => {
        obj.showInVisual = false;
          obj.sortBy = false;
          if(obj.QSlabel){
            obj.QSlabel=obj.QSlabel
          }else{
            obj.QSlabel=""
          }
          if(obj.visibility){
            obj.visibility=obj.visibility
          }else{
            obj.visibility="VISIBLE"
          }
       
      });
      
      this.dataSetObject.rollingUp=JSON.parse(this.selectedDataset.rollingUp)
      this.dataSetObject.rollingUp.forEach(obj => {
        obj.showInVisual = false;
        obj.sortBy = false;
        if(obj.QSlabel){
          obj.QSlabel=obj.QSlabel
        }else{
          obj.QSlabel=""
        }
        if(obj.visibility){
          obj.visibility=obj.visibility
        }else{
          obj.visibility="VISIBLE"
        }
      });
      this.tabularParams.setGridOption('rowData', this.dataSetObject.columns)
      for(let i=0;i<this.dataSetObject.columns.length;i++){
        if(this.dataSetObject.columns[i].showInVisual){
          this.tabularParams.forEachNode(node=>{
            if(node.data["alias"]== this.dataSetObject.columns[i].alias){
                 node.setSelected(true)
            }
          })
        }
      }
      this.tabularconcatinationParams.setGridOption('rowData', this.dataSetObject.concatination)
      // FOR CONCATINATION TO SELECT VALUES IN TABLE
      for(let i=0;i<this.dataSetObject.concatination.length;i++){
        if(this.dataSetObject.concatination[i].showInVisual){
          this.tabularconcatinationParams.forEachNode(node=>{
            if(node.data["alias"]== this.dataSetObject.concatination[i].alias){
                 node.setSelected(true)
            }
          })
        }
      }
      this.tabularaggregateParams.setGridOption('rowData', this.dataSetObject.aggregate)
      // FOR AGGREGATE TO SELECT VALUES IN TABLE
      for(let i=0;i<this.dataSetObject.aggregate.length;i++){
        if(this.dataSetObject.aggregate[i].showInVisual){
          this.tabularaggregateParams.forEachNode(node=>{
            if(node.data["alias"]== this.dataSetObject.aggregate[i].alias){
                 node.setSelected(true)
            }
          })
        }
      }

      this.tabularrollingUpParams.setGridOption('rowData', this.dataSetObject.rollingUp)

      // FOR ROLLING UP TO SELECT VALUES IN TABLE
      for(let i=0;i<this.dataSetObject.aggregate.length;i++){
        if(this.dataSetObject.aggregate[i].showInVisual){
          this.tabularrollingUpParams.forEachNode(node=>{
            if(node.data["rollupColumnAlias"]== this.dataSetObject.aggregate[i].rollupColumnAlias){
                 node.setSelected(true)
            }
          })
        }
      }
    }
    
  }
    

  }
}
